import MyRouterView from "~/core-ui/vue/router/MyRouterView.vue";
import {IRouteMeta} from "~/core-ui/ts/router/Interface";
import Dictionary from "~/ts/library/Dictionary";
import {RouteLocationNormalized, RouteRecordRaw} from "vue-router";
import Random from "~/ts/library/Random";

export default class RouteHelper {

    public static isRouteForGuest(route: RouteLocationNormalized): boolean {
        return route.matched.some(record => (record.meta as IRouteMeta).guest);
    }


    public static isRouteForDealer(route: RouteLocationNormalized): boolean {
        return route.matched.some(record => (record.meta as IRouteMeta).dealer);
    }

    public static isRouteForGuestOrUser(route: RouteLocationNormalized): boolean {
        return route.matched.some(record => (record.meta as IRouteMeta).guestOrUser);
    }

    static toQuery(value: Dictionary<any>): Dictionary<string> {
        return {
            q: JSON.stringify(value)
        }
    }

    static fromQuery(query: Dictionary<string>): any {
        let q = query.q;
        if (q) {
            try {
                return JSON.parse(q as string);
            } catch (e) {
            }
        }
        return null;
    }


    public static setDefaultRoutesComponents(routes: RouteRecordRaw[], force: boolean = false) {
        for (let route of routes) {
            this.setDefaultRouteComponents(route, force);
        }
    }

    public static setDefaultRouteComponents(routeConfig: RouteRecordRaw, force: boolean = false) {
        let hasComponent = (routeConfig as any).component || ((routeConfig as any).components && (routeConfig as any).components.default);
        if (!routeConfig.meta) {
            routeConfig.meta = {};
        }
        if (!routeConfig.name) {
            routeConfig.name = `randomName_${Random.uid()}`;
        }
        let meta: IRouteMeta = routeConfig.meta;

        if (force || !hasComponent) {

            if (!routeConfig.props) {
                routeConfig.props = {};
            }


            if (!hasComponent) {
                if (!(routeConfig as any).components) {
                    (routeConfig as any).components = {};
                }

                (routeConfig as any).components.default = MyRouterView;
            }

            if (meta.keepAlive == null) {
                meta.keepAlive = true;
            }

            if (routeConfig.children) {
                let childrensWithoutParams = routeConfig.children.filter(children => children.path.indexOf(":") == -1);
                if (childrensWithoutParams.length) {
                    meta.redirectToChildren = childrensWithoutParams;
                }
            }
        }
        if (routeConfig.children && routeConfig.children.length > 0) {
            for (let children of routeConfig.children) {
                RouteHelper.setDefaultRouteComponents(children);
            }
        }
    }
}